function UploadModalController(fileService, CommonService, toasterService) {
  const ctrl = this;
  ctrl.installTypeMapper = CommonService.installTypeMapper;

  ctrl.$onInit = () => {
    ctrl.fileDesc = ctrl.resolve.fileDesc;
  };

  ctrl.onAcceptUpload = async () => {
    const headerApproval = {
      id: ctrl.fileDesc.fileId,
      status: 'accepted',
    };

    try {
      await fileService.acceptUpload(headerApproval);
      toasterService.success('toaster.file-upload-success');
      ctrl.ok();
    }
    catch (err) {
      console.error('Error on request', err);
      ctrl.cancel();
    }
  };

  ctrl.onRejectUpload = async () => {
    const headerApproval = {
      id: ctrl.fileDesc.fileId,
      status: 'rejected',
    };

    try {
      await fileService.acceptUpload(headerApproval);
      toasterService.success('toaster.file-upload-removed-success');
      ctrl.ok();
    }
    catch (err) {
      console.error('Error on request', err);
      ctrl.cancel();
    }
  };

  ctrl.ok = () => {
    ctrl.close({ $value: 'accepted' });
  };

  ctrl.cancel = () => {
    ctrl.dismiss();
  };
}

angular
  .module('package-management.module')
  .controller('UploadModalController', UploadModalController);
